import type { Edge2dComputed, Node2d } from "../../mesh"

export const snapPointToSegment = (ab: Edge2dComputed, c: Node2d): Node2d => {
  // copied from https://stackoverflow.com/a/40402936/19118848
  const { p1: a, p2: b } = ab
  const v = {
    x: b.x - a.x,
    y: b.y - a.y,
  }
  const k = ((c.x - a.x) * v.x + (c.y - a.y) * v.y) / (v.x ** 2 + v.y ** 2)

  return {
    x: a.x + k * v.x,
    y: a.y + k * v.y,
  }
}
